import { Flex, IconButton, Td, Tr, Text } from "@chakra-ui/react";
import PropTypes from "prop-types";
import React from "react";
import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";

function EditableTablePageNavigation(props) {
  const { numColumns, numPages, pageNum, setPageNum } = props;

  const incrementPageNum = () => {
    if (pageNum !== numPages) {
      setPageNum(pageNum + 1);
    }
  };

  const decrementPageNum = () => {
    if (pageNum !== 1) {
      setPageNum(pageNum - 1);
    }
  };

  return (
    <Tr userSelect="none">
      <Td colSpan={numColumns} className="pagination-wrapper">
        <Flex align="center" justify="center" flexDirection="row" className="pagination-container">
          {numPages > 1 && <IconButton onClick={decrementPageNum} size="sm" icon={<BiLeftArrowAlt size={24} />} variant="ghost" disabled={pageNum === 1} />}
          <Text>
            Page {pageNum} of {numPages}
          </Text>
          {numPages > 1 && <IconButton onClick={incrementPageNum} size="sm" icon={<BiRightArrowAlt size={24} />} variant="ghost" disabled={pageNum === numPages} />}
        </Flex>
      </Td>
    </Tr>
  );
}

EditableTablePageNavigation.propTypes = {
  numColumns: PropTypes.number.isRequired,
  numPages: PropTypes.number.isRequired,
  pageNum: PropTypes.number.isRequired,
  setPageNum: PropTypes.func.isRequired,
};

export default EditableTablePageNavigation;
